export default {
  districts: [
    {
      title: 'Division 1',
      color: '#cc0000',
      area: [
        { lat: 33.70035029271861, lng: -116.268310546875 },
        { lat: 33.65659607841489, lng: -116.26784344941478 },
        { lat: 33.65659607841489, lng: -116.23385449677806 },
        { lat: 33.627442295974234, lng: -116.23316785127025 },
        { lat: 33.62772816528307, lng: -116.26612683564525 },
        { lat: 33.435696822683255, lng: -116.26441022187572 },
        { lat: 33.435123811862624, lng: -115.82118054658275 },
        { lat: 33.66027770792694, lng: -115.82478256993562 },
        { lat: 33.675707405970904, lng: -115.94631882481843 },
        { lat: 33.683706900394334, lng: -116.01498337559968 },
        { lat: 33.693990870929525, lng: -116.054122169545 },
        { lat: 33.70027491379242, lng: -116.07884140782625 },
        { lat: 33.698023185185995, lng: -116.09515210419994 },
        { lat: 33.673169316193906, lng: -116.09446545869213 },
        { lat: 33.67402646578041, lng: -116.11060162812572 },
        { lat: 33.64287788106662, lng: -116.09000226289135 },
        { lat: 33.64173459926915, lng: -116.1809827926765 },
        { lat: 33.67031208920449, lng: -116.18132611543041 },
        { lat: 33.67031208920449, lng: -116.19093915253978 },
        { lat: 33.685168632915236, lng: -116.19093915253978 },
        { lat: 33.685168632915236, lng: -116.21634503632885 },
        { lat: 33.70030823761816, lng: -116.2160017135749 },
      ],
    },
    {
      title: 'Division 2',
      color: '#007300',
      area: [
        { lat: 33.891665599651674, lng: -116.30183812246912 },
        { lat: 33.82709095613143, lng: -116.30115147696131 },
        { lat: 33.82694835324248, lng: -116.28312703238123 },
        { lat: 33.82138665506334, lng: -116.28278370962732 },
        { lat: 33.82138665506334, lng: -116.2678491698324 },
        { lat: 33.7795910496497, lng: -116.2678491698324 },
        { lat: 33.779305685285145, lng: -116.25514622793787 },
        { lat: 33.77616661452791, lng: -116.23969670401209 },
        { lat: 33.76489354866652, lng: -116.21635075674646 },
        { lat: 33.7002231646799, lng: -116.21652241812342 },
        { lat: 33.7007944188574, lng: -116.1986696349203 },
        { lat: 33.642221111734386, lng: -116.19832631216639 },
        { lat: 33.64250693199194, lng: -116.08777638540857 },
        { lat: 33.67134009199299, lng: -116.10595083452677 },
        { lat: 33.67103706566484, lng: -116.07261920733077 },
        { lat: 33.69918183353436, lng: -116.07344121596384 },
        { lat: 33.68927488392398, lng: -116.03953916957016 },
        { lat: 33.681491302875095, lng: -116.0049375939227 },
        { lat: 33.67949144750793, lng: -115.97918838737974 },
        { lat: 33.6769201365404, lng: -115.95275253532895 },
        { lat: 33.66291942793598, lng: -115.8562788414813 },
        { lat: 33.8892849660687, lng: -115.8604077564958 },
      ],
    },
    {
      title: 'Division 3',
      color: '#e5e500',
      area: [
        { lat: 33.81582498903193, lng: -116.30143310591245 },
        { lat: 33.80127635320644, lng: -116.30108978315855 },
        { lat: 33.80070576806082, lng: -116.2818637089398 },
        { lat: 33.773027822813056, lng: -116.28117706343198 },
        { lat: 33.773027822813056, lng: -116.2862410740521 },
        { lat: 33.757615606205476, lng: -116.28667022749448 },
        { lat: 33.75775765133134, lng: -116.29345375689428 },
        { lat: 33.755259855082144, lng: -116.286288225198 },
        { lat: 33.75176258472206, lng: -116.2791231945451 },
        { lat: 33.74733625889729, lng: -116.2696889043786 },
        { lat: 33.73776979147131, lng: -116.2667861149643 },
        { lat: 33.729200342324354, lng: -116.26887760597793 },
        { lat: 33.72191247496271, lng: -116.26876983141335 },
        { lat: 33.72189995089126, lng: -116.27747886218106 },
        { lat: 33.7145945875665, lng: -116.27738787713668 },
        { lat: 33.71468982706921, lng: -116.26381976579808 },
        { lat: 33.70874179436989, lng: -116.2658661287694 },
        { lat: 33.707413105106966, lng: -116.26875654045097 },
        { lat: 33.70746905444484, lng: -116.27058861096077 },
        { lat: 33.70286976260018, lng: -116.27047666794641 },
        { lat: 33.702810645389356, lng: -116.26870839975243 },
        { lat: 33.69983713253634, lng: -116.26860543642181 },
        { lat: 33.700307258976245, lng: -116.21657509727396 },
        { lat: 33.75720209903404, lng: -116.2165179780448 },
        { lat: 33.777907327876136, lng: -116.25210504429396 },
        { lat: 33.7782209094147, lng: -116.26319896541236 },
        { lat: 33.799966376829346, lng: -116.2632398823219 },
      ],
    },
    {
      title: 'Division 4',
      color: '#0000cc',
      area: [
        { lat: 33.77307103973598, lng: -116.33323263078944 },
        { lat: 33.76536528287434, lng: -116.31949972063319 },
        { lat: 33.7601563688137, lng: -116.30181859880702 },
        { lat: 33.75508986105669, lng: -116.30379270464198 },
        { lat: 33.74372990638903, lng: -116.30387853533045 },
        { lat: 33.74365853553213, lng: -116.32121633440272 },
        { lat: 33.728812106506496, lng: -116.32138799577967 },
        { lat: 33.72895487286417, lng: -116.36078428179042 },
        { lat: 33.714716942307064, lng: -116.36104177385585 },
        { lat: 33.709040705736065, lng: -116.35649284701776 },
        { lat: 33.704221241756926, lng: -116.36430334001795 },
        { lat: 33.70380258896683, lng: -116.37391637712733 },
        { lat: 33.6743076614568, lng: -116.3740022078158 },
        { lat: 33.67362667881269, lng: -116.35624246635723 },
        { lat: 33.568418787808135, lng: -116.35589914360332 },
        { lat: 33.56527201003842, lng: -116.26800851860332 },
        { lat: 33.629615094148996, lng: -116.26732187309551 },
        { lat: 33.6301868173972, lng: -116.23333292045879 },
        { lat: 33.656767757197485, lng: -116.23333292045879 },
        { lat: 33.656767757197485, lng: -116.26800851860332 },
        { lat: 33.69949340559815, lng: -116.2686538696289 },
        { lat: 33.69991865791809, lng: -116.27059448651892 },
        { lat: 33.70724078258812, lng: -116.27054214477539 },
        { lat: 33.70730899170064, lng: -116.26874912671667 },
        { lat: 33.710557681192554, lng: -116.26475799970251 },
        { lat: 33.71459159709528, lng: -116.26411426953894 },
        { lat: 33.714627294620165, lng: -116.2774180262528 },
        { lat: 33.7218817656061, lng: -116.27737511090857 },
        { lat: 33.7218817656061, lng: -116.2686632960282 },
        { lat: 33.72962712288586, lng: -116.26883495740515 },
        { lat: 33.73415968164317, lng: -116.26786942450428 },
        { lat: 33.73869222917371, lng: -116.26647461347204 },
        { lat: 33.74354559315651, lng: -116.26887787274939 },
        { lat: 33.74343170174287, lng: -116.26500727216177 },
        { lat: 33.74617944412786, lng: -116.26698137799673 },
        { lat: 33.757757326969774, lng: -116.29343572587618 },
        { lat: 33.75825683958197, lng: -116.2918907734836 },
        { lat: 33.758185480815555, lng: -116.28656927079805 },
        { lat: 33.7728841323357, lng: -116.28622594804415 },
        { lat: 33.77295547886402, lng: -116.28124776811251 },
        { lat: 33.797449400077646, lng: -116.28150526017794 },
        { lat: 33.800159748758574, lng: -116.28536764115938 },
        { lat: 33.800516367195534, lng: -116.30124631852755 },
        { lat: 33.77583486535265, lng: -116.30124631852755 },
        { lat: 33.772838360718445, lng: -116.3032204243625 },
      ],
    },
    {
      title: 'Division 5',
      color: '#551a8b',
      area: [
        { lat: 33.81637240133637, lng: -116.40533310800191 },
        { lat: 33.84531949163866, lng: -116.40550476937887 },
        { lat: 33.84574720764789, lng: -116.34576661019918 },
        { lat: 33.83120366223055, lng: -116.34542328744527 },
        { lat: 33.831346258021796, lng: -116.33254868417379 },
        { lat: 33.772576659284, lng: -116.33151871591207 },
        { lat: 33.760104223120635, lng: -116.30139071671391 },
        { lat: 33.743619125405964, lng: -116.3036223146143 },
        { lat: 33.743690496295635, lng: -116.32130343644047 },
        { lat: 33.72891545598318, lng: -116.32078845230961 },
        { lat: 33.72891545598318, lng: -116.36078555313969 },
        { lat: 33.72134850827826, lng: -116.3611288758936 },
        { lat: 33.714209266854766, lng: -116.36061389176274 },
        { lat: 33.71206737866521, lng: -116.3475676271143 },
        { lat: 33.704213331561306, lng: -116.37366015641118 },
        { lat: 33.66764686236022, lng: -116.37434680191899 },
        { lat: 33.667218256843974, lng: -116.36095721451665 },
        { lat: 33.627205675565726, lng: -116.35906893937016 },
        { lat: 33.627748828369484, lng: -116.40240915442217 },
        { lat: 33.77201053410006, lng: -116.40395696190052 },
        { lat: 33.772581310482984, lng: -116.38782079246693 },
        { lat: 33.801685863202906, lng: -116.38747746971302 },
        { lat: 33.801685863202906, lng: -116.39674718406849 },
        { lat: 33.81082417298631, lng: -116.396662780922 },
      ],
    },
  ],
};
